/* lib/projectNames.js — the "New project → wizard immediately" contract.
 *
 * The store's "New project" button no longer asks for a name: the project is
 * born with NEW_PROJECT_PLACEHOLDER and the wizard's final Name field renames
 * it (reactEngineWin.finishWizard / engineHandoff.finishWizard PUT {name}).
 * When the user backs out of the wizard before finishing, the untouched
 * placeholder is discarded so nothing lingers in the client's project list. */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Name a project is born with when "New project" opens the wizard directly;
 *  the wizard's final Name field replaces it (finishWizard PUT {name}). */
export const NEW_PROJECT_PLACEHOLDER = "New project";

/** true when the doc is still the untouched placeholder (never named, no wizard
 *  snapshot, no cabinets) — safe to discard when the user backs out. Walls are
 *  deliberately NOT checked: the engine seeds a default wall under the models
 *  screen and may autosave it. */
export function isPlaceholderProject(p) {
  if (!p || p.name !== NEW_PROJECT_PLACEHOLDER) return false;
  const d = p.design || {};
  const n = d._native || {};
  return !(d.cabinets || []).length && !(n.placements || []).length && !n.kitchenWizardSnap && !n.kitchenWizard;
}

/** Best-effort DELETE of an abandoned placeholder. Resolves true when deleted. */
export async function discardPlaceholderProject(p) {
  if (!isPlaceholderProject(p)) return false;
  try {
    await axios.delete(`${API}/projects/${p.id}`);
    return true;
  } catch (_) {
    return false;
  }
}
